module.exports = __webpack_public_path__ + "img/2.8021a0f8.png";